import { useState, useRef, useEffect } from "react"
import { useWeatherCurrentLoading } from "./useWeatherCurrentLoading"

const SHIMMER_SPEED_PX_PER_SEC = 500
const SHIMMER_PAUSE_PX = 100

export const WeatherShimmer = ({ isLight = false }: { isLight?: boolean }) => {
    const { currentWeatherLoading } = useWeatherCurrentLoading()
    const containerRef = useRef<HTMLDivElement>(null)
    const [trackWidth, setTrackWidth] = useState<number>(0)

    useEffect(() => {
        const element = containerRef.current
        if (!element) return

        const updateWidth = () => {
            const width = element.getBoundingClientRect().width
            if (width > 0) setTrackWidth(width)
        }

        updateWidth()

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const width = entry.contentRect.width
                if (width > 0) setTrackWidth(width)
            }
        })

        observer.observe(element)
        return () => observer.disconnect()
    }, [])

    if (!currentWeatherLoading) return null

    const shimmerDurationSec =
        trackWidth > 0 ? (trackWidth + 50 + SHIMMER_PAUSE_PX) / SHIMMER_SPEED_PX_PER_SEC : 1.8

    return (
        <div ref={containerRef} className="absolute inset-0 overflow-hidden pointer-events-none">
            <div
                key={shimmerDurationSec}
                className={`absolute -top-[7px] h-[20px] w-[50px] blur-[20px] pointer-events-none animate-weather-bar-shimmer ${
                    isLight ? "bg-white" : "bg-white/60"
                }`}
                style={
                    {
                        animationDuration: `${shimmerDurationSec}s`,
                        "--shimmer-end": `${trackWidth + SHIMMER_PAUSE_PX}px`,
                    } as React.CSSProperties
                }
            />
        </div>
    )
}
